import {Prop, Vue} from "vue-property-decorator"

export abstract class TwoWayBindable<T> extends Vue {
    @Prop()
    protected value!: T

    abstract input(value: T): T | void
}
